import React from "react";
import { IAlbumApi, cobAlbumApi, odcAlbumApi } from "../api/album";
import { SessionContext } from "../contexts/session";

export function useAlbumApi(): IAlbumApi {
  const sessionContext = React.useContext(SessionContext);
  return sessionContext.migrated ? cobAlbumApi : odcAlbumApi;
}